import { ApiService } from './api.service'

/*
 * Member Hub's authenticated user-journey log (`auth_logs`). Distinct from $tracking,
 * which pushes to GTM/GA4 — that is client-side analytics and is blocked by ad blockers,
 * whereas this is a server-side audit trail used for support and incident forensics.
 *
 * Identity (user_id, email) is derived server-side from the bearer token. Never put
 * email, phone numbers or tokens in the payload — see agent-os/standards/nuxt/logging.md.
 */
class UserLoggingService {
  constructor () {
    this.request = new ApiService()
  }

  /*
     * Posts a single journey event.
     *
     * @param payload - { event, context, ...non-PII detail }
     * @param token - optional access token, for callers whose session is suspended and so
     *                cannot be authenticated by the interceptor (the MFA challenge pages).
     *                Omit it to authenticate normally from the stored session.
     * @returns {*}
     */
  logEvent = (payload, token) => {
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    return this.request.post('/user-logging', payload, config)
  }
}

export default UserLoggingService
